import { useCallback, useEffect, useRef } from 'react'

export const useMount = mount => useEffect(mount, [])

export const useUnmount = unmount => useEffect(() => unmount, [])

export const useSecretTap = (requiredTaps, resetMs, onTrigger) => {
  const tapsRef = useRef(0)
  const timerRef = useRef(null)

  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    },
    []
  )

  return useCallback(() => {
    tapsRef.current += 1
    if (timerRef.current) clearTimeout(timerRef.current)
    if (tapsRef.current >= requiredTaps) {
      tapsRef.current = 0
      onTrigger()
      return
    }
    timerRef.current = setTimeout(() => {
      tapsRef.current = 0
    }, resetMs)
  }, [requiredTaps, resetMs, onTrigger])
}

export const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }
      handler(event)
    }
    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)
    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
}
